(function () {
  function init(box) {
    var track = box.querySelector('[data-media-track]');
    var slides = box.querySelectorAll('[data-media-slide]');
    var prev = box.querySelector('[data-media-prev]');
    var next = box.querySelector('[data-media-next]');
    var dots = box.querySelectorAll('[data-media-dot]');
    if (!track || slides.length < 2) { initVideo(box); return; }

    var i = 0;

    function show(n) {
      i = Math.max(0, Math.min(n, slides.length - 1));
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      Array.prototype.forEach.call(dots, function (d, n2) {
        d.classList.toggle('is-active', n2 === i);
      });
      pauseAll(box);
    }

    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    show(0);
    initVideo(box);
  }

  function pauseAll(box) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-media-video]'), function (v) {
      v.pause();
      v.closest('[data-media-slide]').classList.remove('is-playing');
    });
  }

  function initVideo(box) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-media-video]'), function (video) {
      var slide = video.closest('[data-media-slide]');
      var play = slide.querySelector('[data-media-play]');
      var attached = false;
      if (!play) return;

      play.addEventListener('click', function () {
        if (!attached) {
          var s = document.createElement('source');
          s.src = video.dataset.src;
          s.type = 'video/mp4';
          video.appendChild(s);
          video.load();
          attached = true;
        }
        video.play().catch(function () {});
        slide.classList.add('is-playing');
      });

      video.addEventListener('click', function () {
        video.pause();
        slide.classList.remove('is-playing');
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-media]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
